module.exports = __webpack_public_path__ + "static/media/telethon-shapes-lhs.29fb2ff0.png";